// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607302004/js/" + chunkId + "." + {"44":"b52aa4d8","225":"315336c8","481":"0a9b6e82","486":"07ae9475","770":"a1e3b162"}[chunkId] + ".0.6263858012309472.chunk.js";
};